<div class="component-main-container">
  <!-- Sessão cabeçalho -->
  <div class="header">
    <app-page-header parentTitle="{{ 'lamps-type.lamps-type-label' | translate }}"
      pageTitle="{{ 'lamps-type.generate-lamps-type-label' | translate }}">
    </app-page-header>
  </div>
  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <div class="component-forms-box">
        <!-- Tipos de registros -->
        <app-register-form></app-register-form>

        <!-- Sessão de filtro de tipos Luminárias -->
        <div class="form-fields-box" [ngClass]="!filterLampsBox ? 'closed' : ''" [formGroup]="filterLampsForm">
          <h2 (click)="filterLampsBoxOpen()">
            {{ "lamps-type.filter-lamps-type" | translate }}
          </h2>
          <hr [ngClass]="!filterLampsBox ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "lamps-type.label-reference" | translate }}
              </mat-label>
              <input matInput formControlName="referenceFilterForm" #manufacturer />
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number circle-number-ready">2</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "lamps-type.label-power" | translate }}
              </mat-label>
              <input matInput type="number" min="0" formControlName="powerFilterForm" #power />
            </mat-form-field>
          </div>

          <!-- Botões de filtro -->
          <div class="d-flex m-2">
            @if (!filterLoadingLampsType) {
            <button class="btn btn-success m-1 w-50" (click)="filterLampsType(null)"
              [disabled]="!this.filterLampsForm.get('powerFilterForm')?.value">
              {{ "lamps-type.button-filter" | translate }}
            </button>
            }
            @if (filterLoadingLampsType) {
            <mat-spinner [diameter]="30"></mat-spinner>
            }
            @if (!filterLoadingLampsType) {
            <button class="btn btn-secondary m-1 w-50" (click)="resetFilter()">
              {{ "lamps-type.button-reset-filter" | translate }}
            </button>
            }
          </div>
        </div>

        <!-- Sessão de registro de tipos de Luminárias -->
        <div class="form-fields-box" [formGroup]="registerLampsForm" [ngClass]="!registerLampsBox ? 'closed' : ''">
          <h2 (click)="registerLampsBoxOpen()">
            {{ "lamps-type.register-lamps-type" | translate }}
          </h2>
          <hr [ngClass]="!registerLampsBox ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "lamps-type.label-reference" | translate }}
              </mat-label>
              <input matInput formControlName="modelRegisterForm" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number circle-number-ready">2</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "lamps-type.label-manufacturer" | translate }}
              </mat-label>
              <input matInput formControlName="manufacturerRegisterForm" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number">3</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "lamps-type.dimmings-type" | translate }}
              </mat-label>
              <mat-select formControlName="dimmerTypeRegisterForm">
                <mat-option appearance="outline" value="T_DALI">
                  DALI
                </mat-option>
                <mat-option value="T_1_10V" appearance="outline">
                  1-10V
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Sessão de descrições -->
          <div class="form-step descriptions">
            <div class="circle-number circle-number-ready">4</div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "lamps-type.descriptions-power" | translate }}
              </mat-label>
              <input matInput type="number" min="0" formControlName="powerRegisterForm" title="Potência(W)" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>
                {{ "lamps-type.descriptions-brightness" | translate }}
              </mat-label>
              <input matInput type="number" min="0" formControlName="brightnessRegisterForm" title="Brilho(K)" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>
                {{ "lamps-type.descriptions-consumption" | translate }}
              </mat-label>
              <input matInput type="number" min="0" formControlName="consumptionRegisterForm" title="Consumo" />
            </mat-form-field>
          </div>

          <!-- Sessão de descrições -->
          <div class="form-step descriptions">
            <app-circle-number stepNumber="4.1" [isSubstep]="true">
            </app-circle-number>
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "lamps-type.descriptions-current" | translate }}
              </mat-label>
              <input matInput type="number" min="0" formControlName="currentRegisterForm" title="Corrente(mA)" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>
                {{ "lamps-type.descriptions-powerFactor" | translate }}
              </mat-label>
              <input matInput type="number" min="0" formControlName="powerFactorRegisterForm"
                title="Fator de potência" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>
                {{ "lamps-type.descriptions-voltage" | translate }}
              </mat-label>
              <input matInput type="number" min="0" formControlName="voltageRegisterForm" title="Tensão(V)" />
            </mat-form-field>
          </div>

          <!-- botão de registro de tipos de luminárias -->
          <button class="btn btn-success" (click)="createLampsType()">
            {{ "lamps-type.button-save" | translate }}
          </button>
        </div>
      </div>
    </div>

    <!-- Sessão table header -->
    <div class="col-lg-7 col-xl-8 col-sm-12">
      @if (length > 0) {
      <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
        [hasCSV]="true" [hasPDF]="true" (downloadCSV)="generateFileData(null, 'CSV')"
        (downloadPDF)="generateFileData(null, 'PDF')" [loadingData$]="fileLoading">
      </app-table-header>
      }
      <!-- Sessão da Tabela -->
      @if (ELEMENT_DATA.length) {
      <div class="table-container mt-2 mt-lg-3 mt-lg-3">
        <p-table [value]="ELEMENT_DATA" dataKey="id" [paginator]="true" (onPage)="pageChanged($event)" [rows]="pageSize"
          [totalRecords]="length" [showFirstLastIcon]="false" [showPageLinks]="false" [lazy]="true">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="manufacturer">{{ "lamps-type.manufacturer-table" | translate }}
              </th>
              <th pSortableColumn="power"> {{ "lamps-type.power-table" | translate }}
              </th>
              <th pSortableColumn="dimmingType"> {{ "lamps-type.dimming-type-table" | translate }}
              </th>
              <th pSortableColumn="description"> {{ "lamps-type.description-table" | translate }}
              </th>
              <th pSortableColumn="actions">{{ "lamps-type.actions-table" | translate }}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td> {{row.manufacturer}}</td>
              <td> {{row.power}}</td>
              <td> @if (row.dimmingType === 'T_DALI') {
                <span>DALI</span>
                }
                @if (row.dimmingType === 'T_1_10V') {
                <span>1-10V</span>
                }
              </td>
              <td> {{ "lamps-type.brightness-table" | translate }} ({{
                row.brightness
                }}) {{ "lamps-type.consumption-table" | translate }}({{
                row.consumption
                }})<br />
                {{ "lamps-type.current-table" | translate }} ({{
                row.current
                }}) {{ "lamps-type.power-factor-table" | translate }} ({{
                row.powerFactor
                }}) <br />
                {{ "lamps-type.voltage-table" | translate }} ({{
                row.voltage
                }})</td>
              <td>
                <p-button (click)="
                  updateGetter(
                    row.id,
                    row.model,
                    row.brightness,
                    row.consumption,
                    row.current,
                    row.dimmingType,
                    row.manufacturer,
                    row.power,
                    row.powerFactor,
                    row.voltage,
                    false
                  )
                " styleClass="btn-actions" [rounded]="true" icon="pi pi-pen-to-square" />

                <p-button (click)="
                  updateGetter(
                    row.id,
                    row.model,
                    row.brightness,
                    row.consumption,
                    row.current,
                    row.dimmingType,
                    row.manufacturer,
                    row.power,
                    row.powerFactor,
                    row.voltage,
                    true
                  )
                " styleClass="btn-view" [rounded]="true" icon="pi pi-eye" />
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      }
    </div>
  </div>

  <!-- Componente de edição -->
  @if (editorController) {
  <div class="sidebar-edit" [formGroup]="updateForm">
    <mat-icon (click)="closeEditionSideBar()">clear</mat-icon>
    @if (viewController === false) {
    <h2>
      {{ "lamps-type.form-edit-label" | translate }}
    </h2>
    }
    @if (viewController === true) {
    <h2>
      {{ "lamps-type.form-view-label" | translate }}
    </h2>
    }
    <hr />
    <mat-form-field appearance="outline">
      <mat-label> {{ "lamps-type.label-reference" | translate }} </mat-label>
      <input matInput formControlName="modelUpdateForm" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label> {{ "lamps-type.label-manufacturer" | translate }} </mat-label>
      <input matInput formControlName="manufacturerUpdateForm" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label> {{ "lamps-type.dimmings-type" | translate }} </mat-label>
      <mat-select formControlName="dimmerTypeUpdateForm">
        <mat-option appearance="outline" value="T_DALI"> DALI </mat-option>
        <mat-option value="T_1_10V" appearance="outline"> 1-10V </mat-option>
      </mat-select>
    </mat-form-field>
    <!-- Sessão de descrições -->
    <div class="form-step descriptions">
      <mat-form-field appearance="outline">
        <mat-label>
          {{ "lamps-type.descriptions-power" | translate }}
        </mat-label>
        <input matInput type="number" min="0" formControlName="powerUpdateForm" title="Potência(W)" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>
          {{ "lamps-type.descriptions-brightness" | translate }}
        </mat-label>
        <input matInput type="number" min="0" formControlName="brightnessUpdateForm" title="Brilho(K)" />
      </mat-form-field>
    </div>
    <div class="form-step descriptions">
      <mat-form-field appearance="outline">
        <mat-label>
          {{ "lamps-type.descriptions-consumption" | translate }}
        </mat-label>
        <input matInput type="number" min="0" formControlName="consumptionUpdateForm" title="Consumo" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>
          {{ "lamps-type.descriptions-current" | translate }}
        </mat-label>
        <input matInput type="number" min="0" formControlName="currentUpdateForm" title="Corrente(mA)" />
      </mat-form-field>
    </div>
    <div class="form-step descriptions">
      <mat-form-field appearance="outline">
        <mat-label>
          {{ "lamps-type.descriptions-powerFactor" | translate }}
        </mat-label>
        <input matInput type="number" min="0" formControlName="powerFactorUpdateForm" title="Fator de potência" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>
          {{ "lamps-type.descriptions-voltage" | translate }}
        </mat-label>
        <input matInput type="number" min="0" formControlName="voltageUpdateForm" title="Tensão(V)" />
      </mat-form-field>
    </div>
    @if (!viewController) {
    <button class="btn btn-success" (click)="updateLampType()">
      {{ "lamps-type.form-edit-button" | translate }}
    </button>
    }
  </div>
  }
</div>